import React, { memo, useState } from 'react';

import { ConfirmationModal } from '~/Components';
import { useLanguage } from '~/Hooks';
import { EditEventOption } from '~/Screens/Calendar/constants';
import { EditCalendarEventModalContent } from './components';
import { ICalendarEventBookings } from '~/Screens/Calendar/interfaces';

interface IEditCalendarEventConfirmationModal {
  confirmationOptions: ICalendarEventBookings;
  onCloseEditEvent: () => void;
  onConfirmEditEvent: (selectedOption: EditEventOption) => void;
  eventName?: string;
}

export const EditCalendarEventConfirmationModal = memo(
  ({
    confirmationOptions,
    onCloseEditEvent,
    onConfirmEditEvent,
    eventName = '',
  }: IEditCalendarEventConfirmationModal) => {
    const { t } = useLanguage();
    const [selectedOption, setSelectedOption] = useState<EditEventOption>(
      EditEventOption.SINGLE_EVENT,
    );

    return (
      <ConfirmationModal
        open={!!confirmationOptions}
        title={t('app.event.editEvent')}
        cancel={{ action: onCloseEditEvent }}
        confirm={{
          action: () => onConfirmEditEvent(selectedOption),
          hidden: confirmationOptions.eventHasBookings,
          disabled: !selectedOption,
          title: t('app.confirmationModal.confirm'),
        }}
      >
        <EditCalendarEventModalContent
          eventName={eventName}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          confirmationOptions={confirmationOptions}
        />
      </ConfirmationModal>
    );
  },
);
